export default __webpack_public_path__ + "static/media/18.09c0c233.svg";